import { message, Modal } from "antd";
import { ICategoryAddCallback, api } from "./index";
import { lang } from "../context";
import events from "../context/events";
import { ActionFnEnum, ActionType } from "../types";
const Remove: ICategoryAddCallback = (props, isAllow, isTeam?: boolean) => {
  const { data, remove, setData } = props;
  const isGroup = data.type === 3;
  return [
    {
      children: lang("common.delete"),
      icon: "pc_yundoc_recycle",
      splitCode: 3,
      callbackOrModal: () => {
        Modal.confirm({
          title: `是否确认删除"${data.name ? data.name : "无标题"}" 文件夹？`,
          content: isGroup ? "删除后不可恢复，请谨慎操作" : "删除的文件夹可在回收站找回",
          cancelText: lang("common.cancel"),
          okText: lang("common.confirm"),
          onOk: () => {
            isGroup
              ? api.categories
                  .deleteFolder(props.data.id, 0)
                  .then((data1) => {
                    if (data1) {
                      setData({
                        type: ActionFnEnum.REMOVE,
                        id: props.data.id,
                        actionType: ActionType.Folder
                      } as any);
                      events.emit("list.check");
                      events.emit("deleteFolderById", props.data.id);
                      message.success(lang("common.success"));
                    } else {
                      message.error(lang("common.fail"));
                    }
                  })
                  .catch((err) => {
                    message.error(lang("common.fail"));
                  })
              : api.categories
                  .remove(props.data.id, isTeam)
                  .then((data1) => {
                    if (data1 && typeof data1 === "boolean") {
                      setData({
                        type: ActionFnEnum.REMOVE,
                        id: props.data.id,
                        actionType: ActionType.Folder
                      } as any);
                      events.emit("list.check");
                      events.emit("deleteFolderById", props.data.id);
                      message.success(lang("common.success"));
                    } else {
                      message.error(lang("common.fail"));
                    }
                  })
                  .catch((err) => {
                    message.error(lang("common.fail"));
                  });
            // deleteFolderById(props.data.id)
            //     .then((data: any) => {
            //         if (data) {
            //             message.success(lang('common.success'));
            //             props.reload();
            //         } else {
            //             message.error(lang('common.error'));
            //         }
            //     })
            //     .catch((err: any) => {
            //         console.log('err', err);
            //         message.error(lang('common.error'));
            //     });
          }
        });
      },
      type: "delete",
      isAllow
    }
  ];
};
export default Remove;
